module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.klassHasNoSubjects && _vm.theCalendar) ? _c('p', {
    staticClass: "center italic text-dark marg-on-top"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_subjects_created']) + "\n  "), _c('span', {
    staticClass: "text-link",
    on: {
      "click": _vm.setImportSubjects
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['import_subjects']))]), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['or_click_on_create_subject']))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a1aaf70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/ImportSubjectsToKlass.vue
// module id = 2029
// module chunks = 1